import intlLocale from './intlLocale';

const formatNumber = (value, minDigits = 0, maxDigits = 2) => {
  return new Intl.NumberFormat(intlLocale(),
    {minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits}
  ).format(value);
};

export default formatNumber;
